import type { Ref, WritableComputedRef } from 'vue'
import { computed, ref } from 'vue'
import type { ThreeSixtyFragment } from '@/graphql/api'

export interface ThreeSixtyImages {
    currentImageIndex: WritableComputedRef<number, number>
}

export function useThreeSixtyImages(
    images: Readonly<Ref<ThreeSixtyFragment[]>>,
    initialIndex?: number
): ThreeSixtyImages {
    const state = ref(initialIndex ?? 0)

    const currentImageIndex = computed({
        get: () => state.value,
        set: (value) => {
            const imageCount = images.value.length

            if (value < 0) {
                let v = imageCount + (value % imageCount)

                if (v === imageCount) {
                    v = 0
                }
                state.value = v
            } else if (value > imageCount - 1) {
                state.value = value % imageCount
            } else {
                state.value = value
            }
        },
    })

    return {
        currentImageIndex,
    }
}
